import { Button } from "@/components/ui/button";
import { Card, CardBody, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { BadgeStatus } from "@/components/ui/badge-status";
import { SourceChip } from "@/components/ui/source-chip";
import { CopyButton } from "@/components/ui/copy-button";
import { ExportDropdown } from "@/components/ui/export-dropdown";
import { Section, FieldGroup, FormGrid } from "@/components/ui/section";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Internal kitchen-sink showcase — every reusable primitive in one
 * place so design tweaks are visible before they ripple into the real
 * pages. Visit at ``/app/_kitchen``.
 */
export function KitchenPage() {
  return (
    <TooltipProvider delayDuration={150}>
      <div className="mb-2 text-[0.72rem] uppercase tracking-[0.05em] text-stone-400">
        Internal — Sprint A primitive showcase
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Buttons</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex flex-wrap gap-3">
            <Button variant="primary">Primary</Button>
            <Button variant="success">Success</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="danger">Danger</Button>
            <Button variant="primary" disabled>
              Disabled
            </Button>
          </div>
          <div className="mt-3 flex flex-wrap gap-3">
            <Button size="sm">Small</Button>
            <Button>Default</Button>
            <Button size="lg">Large</Button>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Status badges</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex flex-wrap items-center gap-3">
            <BadgeStatus kind="ok">OK</BadgeStatus>
            <BadgeStatus kind="warn" title="Validator warning text">
              2 upoz.
            </BadgeStatus>
            <BadgeStatus kind="err">3 greška(e)</BadgeStatus>
            <SourceChip factKeys={["openings_schedule", "total_glazed_area_m2"]} />
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Form primitives</CardTitle>
        </CardHeader>
        <CardBody>
          <Section title="Demo grupa">
            <FormGrid cols={2}>
              <FieldGroup>
                <Label htmlFor="demo-name" required>
                  Naziv
                </Label>
                <Input id="demo-name" placeholder="ZETA HOME 23 d.o.o." />
              </FieldGroup>
              <FieldGroup>
                <Label htmlFor="demo-oib">OIB</Label>
                <Input id="demo-oib" placeholder="19090657098" />
              </FieldGroup>
              <FieldGroup full>
                <Label htmlFor="demo-desc">Opis</Label>
                <Textarea id="demo-desc" placeholder="Slobodan tekst..." />
              </FieldGroup>
            </FormGrid>
          </Section>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Toolbar pieces</CardTitle>
          <div className="flex items-center gap-2">
            <CopyButton text="Hello, world." />
            <ExportDropdown onExport={(fmt) => console.log("export", fmt)} />
          </div>
        </CardHeader>
        <CardBody>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="outline">Hover me</Button>
            </TooltipTrigger>
            <TooltipContent>This is a Radix tooltip on shadcn-style chrome.</TooltipContent>
          </Tooltip>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Tabs</CardTitle>
        </CardHeader>
        <CardBody>
          <Tabs defaultValue="one">
            <TabsList>
              <TabsTrigger value="one">First</TabsTrigger>
              <TabsTrigger value="two">Second</TabsTrigger>
              <TabsTrigger value="three">Third</TabsTrigger>
            </TabsList>
            <TabsContent value="one" className="pt-4 text-stone-600">
              First panel.
            </TabsContent>
            <TabsContent value="two" className="pt-4 text-stone-600">
              Second panel.
            </TabsContent>
            <TabsContent value="three" className="pt-4 text-stone-600">
              Third panel.
            </TabsContent>
          </Tabs>
        </CardBody>
      </Card>
    </TooltipProvider>
  );
}
